<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>

    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="insurers"
                label="Compagnie"
                :options="companies"
                v-model="filter.byInsurer.id"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="mappable_id"
                label="Mappato"
                v-model="filter.byImport"
                :options="opt_map"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="map"
                type="text"
                label="Codice Compagnia"
                v-model="filter.byAttribute.map"
                placeholder="Inserisci un codice compagnia"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <import-maps
        :fields="fields"
        @manualFetch="manualFetch"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :filterOn="{
          byRelations: ['byInsurer'],
        }"
        :onlyActions="['infomodal']"
        :ref="tableRef"
      ></import-maps>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import ImportMaps from "@/components/tables/ImportMapsInsurerParticipants.vue";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import { mapGetters, mapActions } from "vuex";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "import_map",
      resource: "import_maps",
      context: "profile_import_maps_insurer_participant",
      tableRef: "ImportMapsInsurerParticipantsTableRef",
      filterName: "filterImportMapsInsureParticipants",
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      companies: [],
      opt_map: [
        { text: "No", value: "treasury" },
        {
          text: "Si",
          value: "treasury2",
        },
      ],
      fields: [
        {
          key: "insurer.formatted_title",
          label: this.getDictionary("map", "import_map"),
          sortable: true,
          sortKey: "byInsurer.formatted_title",
        },
        {
          key: "map",
          label: this.getDictionary("code", "insurer"),
          sortable: true,
          sortKey: "map",
        },
        {
          key: "mapped",
          label: this.getDictionary("insurer_id", "import_map"),
        },
        {
          key: "insurer_participant",
          label: this.getDictionary("insurer_participant"),
        },
      ],
    };
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  components: {
    BaseIcon,
    ImportMaps,
    BaseSelect,
    BaseInput,
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          mappable_temp: "insurer_participant",
          mappable_id: null,
          map: null,
        },
        byImport: null,
        byImportSuccess: null,
        byInsurer: {
          id: null,
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byAttribute.mappable_temp"];
      delete this.activeFilters["byImportSuccess"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      if (this.filter.byImport === "treasury2") {
        this.filter.byImport = null;
        this.filter.byImportSuccess = "treasury";
      } else {
        this.filter.byImportSuccess = null;
      }
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
    }),
  },
  mounted() {
    this.onSearch(this.filterName);
    this.companies = this.getInsurers();
    // this.$refs[this.tableRef].fetch();
  },
};
</script>
